export const STAGE_0 = { key: -1, title: '' };
export const STAGE_1 = { key: 1, title: 'Etap I (Szkolny)' };
export const STAGE_2 = { key: 2, title: 'Etap II (Pisemny)' };
export const STAGE_3 = { key: 3, title: 'Etap II (Ustny)' };
export const STAGE_4 = { key: 4, title: 'Etap III (Pisemny)' };
export const STAGE_5 = { key: 5, title: 'Etap III (Ustny)' };

export const STAGES_TITLES = [STAGE_1, STAGE_2, STAGE_3, STAGE_4, STAGE_5];
